module.exports = __webpack_public_path__ + "static/fan-band-7dad4395eb6dcc1c0228dabbe9108629.jpg";